import { UsersActionTypes } from './constants';

type UsersAction = { type: string, payload: {} | string };

export const usersApiResponseSuccess = (actionType: string, data: any): UsersAction => ({
    type: UsersActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const usersApiResponseError = (actionType: string, error: string): UsersAction => ({
    type: UsersActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const usersGetAllUsers = (query): UsersAction => ({
    type: UsersActionTypes.GET_ALL_USERS,
    payload: { query },
});

export const usersResetAllErrors = (): UsersAction => ({
    type: UsersActionTypes.RESET_ALL_ERRORS,
    payload: {},
});
